import Form from "./form";
import { AttendanceLocal } from "../../../../../../../../../../../@types/attendance-local";
import { AttendanceLocalDepartment } from "../../../../../../../../../../../@types/attendance-local-department";
import { useAttendanceLocalDepartmentGuicheCreate } from "../../../../../../../../../../../services/api-tansquery/attendance-local/department/guiche/create";

type FormCreateProps = {
    departmentId: AttendanceLocalDepartment["id"];
    slug: AttendanceLocal["slug_unidade"];
    buttonTrigger?: React.ReactNode;
};

export default function FormCreate(props: FormCreateProps) {
    const mutation = useAttendanceLocalDepartmentGuicheCreate();

    return (
        <Form
            {...props}
            mutation={mutation}
        />
    );
}
